/**
 * Caminho absoluto no mesmo host, respeitando import.meta.env.BASE_URL (VITE_BASE_PATH).
 * Usar em window.location / links hardcoded — router.push já resolve a base sozinho.
 *
 * @param {string} relativePath ex.: "auth/login" ou "/auth/login"
 * @returns {string} ex.: "/auth/login" ou "/DragonPanel/auth/login"
 */
export function resolveAppPath(relativePath) {
  const rel = String(relativePath || '').replace(/^\/+/, '')
  const rawBase = String(import.meta.env.BASE_URL || '/').replace(/\/+$/, '')
  const base = rawBase === '' || rawBase === '.' ? '' : rawBase
  if (!base || base === '/') {
    return `/${rel}`.replace(/\/{2,}/g, '/')
  }
  return `${base}/${rel}`.replace(/\/{2,}/g, '/')
}

/**
 * URL absoluta no host actual (checkuser DTunnel / Conecta4G para apps externos).
 *
 * @param {string} path ex.: "/checkuser/conecta4g"
 */
export function panelPublicAbsoluteUrl(path) {
  const rel = String(path || '').replace(/^\/+/, '')
  const pathname = resolveAppPath(rel)
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${pathname}`
  }
  return pathname
}

/** URL base do painel (login SPA), sem /admin ou outros paths. */
export function panelPublicBaseUrl() {
  return panelPublicAbsoluteUrl('/').replace(/\/$/, '')
}
